import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  IconButton,
  Avatar,
  Grid,
} from "@mui/material"
import SearchRoundedIcon from "@mui/icons-material/SearchRounded"
import { useState } from "react"
import { getAllStudents } from "../../api"
import { useSnackbar } from "notistack"
import { useEffect } from "react"
import { AccountCircle, Delete, Reply, Send } from "@mui/icons-material"
import { Box } from "@mui/system"

const DiscussionTab = ({ batchId }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")
  const handleSearchChange = (event) => setSearch(event.target.value)

  const fetchStudents = () => {
    getAllStudents()
      .then((res) => console.log(res.data))
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchStudents()
  }, [])

  return (
    <Grid
      container
      style={{ overflow: "hidden", paddingBottom: "0.2rem" }}
    >
      <Grid
        container
        item
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Grid item>
          <Typography variant="h5" style={{ color: "#565656" }}>
            Welcome to the Course!
          </Typography>
          <Typography variant="h6" style={{ color: "#89969f" }}>
            Start a discussion...
          </Typography>
        </Grid>

        <Grid item>
          <TextField
            value={search}
            onChange={handleSearchChange}
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container item sx={{ display: "flex", mt: "1rem" }}>
        <Box sx={{ display: "flex", alignItems: "flex-end", width: "100%" }}>
          <AccountCircle sx={{ color: "action.active", mr: 1, my: 0.5 }} />
          <TextField
            id="input-with-sx"
            label="Start a new discussion"
            variant="standard"
            fullWidth
            multiline
            sx={{ width: "100%" }}
          />
          <IconButton sx={{ ml: "1rem" }}>
            <Send />
          </IconButton>
        </Box>
      </Grid>
      <DayToast />
      <DiscussionCard />
      <DiscussionCard />
    </Grid>
  )
}
const DayToast = ({ name }) => {
  const numberStyle = {
    position: "absolute",
    left: "50%",
    transform:
      //   name === moment().format("DD MMM, YYYY")
      //     ? "translateX(-80%)"
      "translateX(-60%)",
    background: "#fff",
    margin: "0 1rem",
    padding: "0 1rem",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: 500,
    color: "#565656",
  }

  return (
    <Grid
      container
      item
      style={{
        display: "flex",
        alignItems: "center",
        margin: "20px 0",
        height: "30px",
        width: "100%",
        position: "relative",
      }}
    >
      <hr
        style={{
          background: "rgba(196, 196, 196, 0.5)",
          width: "100%",
          height: "0.5px",
          border: "none",
        }}
      />
      <Typography variant="h3" style={numberStyle}>
        10 Sep, 2021
      </Typography>
    </Grid>
  )
}

const DiscussionCard = () => {
  return (
    <Stack
      sx={{
        backgroundColor: "#fff",
        borderRadius: 3,
        p: 3,
        my: 2,
        width: "100%",
      }}
      gap={2}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
      >
        <Stack direction="row" alignItems={"center"} spacing={2}>
          <Avatar sx={{ width: 56, height: 56 }}>S</Avatar>
          <Stack>
            <Typography variant="h6">Subject or topic of this post</Typography>
            <Typography variant="body 1" color="text.secondary">
              Name of student
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="body2" color="text.secondary">
            2h ago
          </Typography>
        </Stack>
      </Stack>
      <Typography>
        This is discussion message, discussion will be shown here
      </Typography>
      <Comment />
      <Comment />
      <Comment />
      <Comment />
      <Stack direction="row" sx={{ alignItems: "center" }} gap={2}>
        <Avatar>S</Avatar>
        <TextField
          fullWidth
          size="small"
          InputProps={{ sx: { borderRadius: "99999px" } }}
        />
      </Stack>
    </Stack>
  )
}

const Comment = () => (
  <Stack direction="row" gap={2}>
    <Avatar>S</Avatar>{" "}
    <Box sx={{ p: 1, px: 2, background: "rgba(0,0,0,0.05)", borderRadius: 2 }}>
      <Stack direction="row" gap={1} alignItems="center">
        <Typography sx={{ fontWeight: 600 }}>Student 2 </Typography>
        <span style={{ color: "gray", fontSize: 12 }}>2m</span>
      </Stack>
      This is a generic comment
    </Box>
  </Stack>
)

export default DiscussionTab
